export { default as TrashOutlineIcon } from './TrashOutlineIcon';
